<template>
    <DCard
        padding
    >
        <Form
            :countries="countries"
            :errors="errors"
            :tax-rule-credit-note="taxRuleCreditNote"
            :customer-types="customerTypes"
            :credit-note-types="creditNoteTypes"
            :default-tenant-language="defaultTenantLanguage"
            :tenant-languages="tenantLanguages"
            :effectiveness="effectiveness"
            :is-finance-system-netsuite="isFinanceSystemNetsuite"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/TaxRulesCreditNotes/Form'

export default {
    name: 'TaxRulesCreditNotesUpdate',
    components: {
        Form
    },
    props: {
        countries: {
            type: Array,
            default: () => { return [] }
        },
        customerTypes: {
            type: Array,
            default: () => { return [] }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        taxRuleCreditNote: {
            type: Object,
            default: () => { return {} }
        },
        creditNoteTypes: {
            type: Array,
            default: () => { return [] }
        },
        defaultTenantLanguage: {
            type: String,
            default: ''
        },
        tenantLanguages: {
            type: Array,
            default: () => []
        },
        effectiveness: {
            type: Array,
            default: () => []
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    methods: {
        submitData (form) {
            form.put(this.$route('settings.tax-rules-credit-notes.update', { tax_rules_credit_note: this.taxRuleCreditNote.id }))
        }
    }
}
</script>
